'use strict';

import React from 'react';
import BusinessBrief from './BusinessBriefComponent';
import BusinessMediaList from './BusinessMediaListComponent'
import PostCardComponent from './PostCardComponent'
import API from 'sources/API';
import BusinessActions from 'actions/BusinessActions';
import BusinessStore from 'stores/BusinessStore';
import AlbumActions from 'actions/AlbumActions';
import AlbumStore from 'stores/AlbumStore';
import Navigator from './NavigatorComponent';

import Progress from 'antd/lib/progress';
import 'antd/lib/progress/style/css';

require('styles/BusinessArticle.scss');
let $ = window.$
class BusinessArticleComponent extends React.Component {
  constructor(props) {
    super(props);
    let albumStore = AlbumStore.getState()
    this.state = {
      album: albumStore.album,
      albumMedia: albumStore.albumArticleMedia,
      isCollect: albumStore.album.isCollect,
      totalPrice: albumStore.totalPrice,
      paySignature: albumStore.paySignature,
      fileProgress: 0,
      uploading: false,
      firstUpload: false,
      product: null,
      isAuthor: false,
      loading: true,
      hasMore: true,
      showNavigator: false,
      isShare: false,
      business: {},
      invite_url: '',
      oauth: false,
      businessOauth: false,
      name: '',
      desc: '',
      productTitle: '',
      productCover: '',
      productPrice: 0,
      productUrl: '',
      localImage: '',
      city_id: '',
      city_name: '',
      cities: [],
      showPostCard: false,
      inputTimeout: null,
      isShare: false
    }
    this.handleTextChange = this.handleTextChange.bind(this)
    this.onBusinessChange = this.onBusinessChange.bind(this)
    this.onAlbumChange = this.onAlbumChange.bind(this)
    this.getInviteUrl = this.getInviteUrl.bind(this)
    this.checkOauth = this.checkOauth.bind(this)
    this.updateProduct = this.updateProduct.bind(this)
    this.updateArticle = this.updateArticle.bind(this)
    this.saveProduct = this.saveProduct.bind(this)
    this.onCityInputChange = this.onCityInputChange.bind(this)
    this.picUpload = this.picUpload.bind(this)
    this.pickCity = this.pickCity.bind(this)
    this.togglePostCard = this.togglePostCard.bind(this)
  }
  getInviteUrl(){
    let sendData = {
      business_id: this.props.params.bid,
      article_id: this.props.params.id
    }
    let param = {
      method: 'POST',
      body: JSON.stringify(sendData),
      headers: API.jsonHeader
    }
    fetch(`${API.getAgentInviteUrl}`,param).then(res=>res.json()).then(json=>{
      if(json.status == 0){
        let url = json.result
        this.setState({
          invite_url: url
        })
      }
    });
  }
  componentWillMount(){
    let { query } = this.props.location;
    if(query.type === 'share'){
      this.setState({isShare:true});
    }
  }
  componentDidMount() {
    this.checkOauth()
    if(API.isWechat){
      fetch(API.getWechatConfig).then(res=>res.json()).then(json=>{
        if(json.appId) {
            window.wx.config(json);
        }
      })
    }

    BusinessStore.listen(this.onBusinessChange)
    AlbumStore.listen(this.onAlbumChange)

    AlbumActions.cleanAlbumMedia();
    BusinessActions.fetchBusiness(this.props.params.bid)
    AlbumActions.fetchAlbumDetail(this.props.params.id);
    AlbumActions.fetchAlbumArticleMedia(this.props.params.id)

    // Baidu tongji
    window._hmt.push(['_trackPageview', this.props.location.pathname]);
  }
  componentWillUnmount() {
    BusinessStore.unlisten(this.onBusinessChange)
    AlbumStore.unlisten(this.onAlbumChange)
  }
  onBusinessChange(state){
    this.setState({
      business: state.business
    })
  }
  onAlbumChange(state){
    let album = state.album
    let albumArticleMedia = state.albumArticleMedia
    if(album && albumArticleMedia.length){
      album.cover = albumArticleMedia[0].images.big[0].replace('!li750','')
    }
    let product  = album.product
    let newState = {
      album: album,
      product: product,
      albumMedia: albumArticleMedia,
      totalPrice: state.totalPrice,
      paySignature: state.paySignature,
      isCollect: state.album.isCollect || false,
      isAuthor: state.album.isAuthor || false,
      loading: state.loading,
      hasMore: state.moreAlbumMedias
    }
    if(product && !product.is_random){
      newState.productTitle = product.title
      newState.productCover = product.cover.small.replace('!li150','')
      newState.productPrice = product.price
      newState.productUrl   = product.url
    }
    if(album){
      newState.name = album.name
      newState.desc = album.desc
    }
    this.setState(newState);

    let albumName = album.name;
    let brandName = this.state.business.name;
    let cover = state.albumArticleMedia[0]?state.albumArticleMedia[0].images.big[0]:"";
    window.wx.ready(()=>{
      window.wx.onMenuShareTimeline({
        title: `${albumName}-${brandName}`,
        link: `${location.href.split('?')[0]}?type=share`,
        imgUrl: encodeURI(cover||'https://img.xiaodiqiu.cn/share.png')
      });
      window.wx.onMenuShareAppMessage({
        title: `${albumName}-${brandName}`,
        desc: `分享一篇${brandName}美文——${albumName}。加入${brandName}，发现有趣的地方`,
        link: `${location.href.split('?')[0]}?type=share`,
        imgUrl: encodeURI(cover||'https://img.xiaodiqiu.cn/share.png'),
        type: 'link'
      });
    });

    // SEO 优化
    let title = albumName;
    window.changeMetaForSEO(title);
  }
  onCityInputChange(event){
    this.setState({'city_name': event.target.value});
    if(this.state.inputTimeout) {
      clearTimeout(this.state.inputTimeout);
    }
    let key = event.target.value;
    let that = this;
    let searchCity = function() {
      fetch(`${API.getCityList}&key=${key}`)
        .then(res=>res.json())
        .then(json=>{
          that.setState({cities: json.result});
        });
    }
    this.setState({inputTimeout: setTimeout(searchCity, 1000)});
  }
  togglePostCard(){
    this.setState({
      showPostCard: !this.state.showPostCard
    })
  }
  pickCity(city) {
    this.setState({
      city_id: city._id,
      city_name: city.name,
      cities: []
    });
  }
  picUpload(event) {
    let that = this;
    this.setState({fileProgress:0,uploading:true,firstUpload:true});
    let progresses = [0,10,33,40,66,84,95];
    progresses.forEach((value,index) => {
      setTimeout(() => {
        if(that.state.uploading){
          that.setState({fileProgress: value});
        }
      },150 * index)
    });
    let img = event.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(img);
    let formData = new FormData();
    formData.append('file', img);
    fetch(`${API.imageUpload}`, {
      method: 'POST',
      body: formData
    }).then(res=>res.json())
    .then(json=>{
      if(json.status === 0) {
        that.setState((previousState)=>{
          previousState.productCover = json.url;
          previousState.uploading = false;
          previousState.fileProgress = 100;
          return {
            productCover: previousState.productCover
          };
        });
      }
    });
  }
  updateArticle(){
    if(!this.state.name){
  	  this.setState({
  		error: "合辑标题不能为空"
  	  });
  	  return;
  	}
  	let sendData = {
      business_id: this.props.params.bid,
      article_id: this.props.params.id,
      name: this.state.name,
      desc: this.state.desc
    };
    let params = {
      method: 'POST',
      headers: API.jsonHeader,
      body: JSON.stringify(sendData)
    };
    fetch(API.postUpdateBAlbum.replace(':id',this.props.params.bid), params).then(res => res.json())
    .then(json => {
      if(json.status == 0){
        window.location.reload()
      }
    })
  }
  updateProduct(){
    let sendData = {
      product_id: this.state.product._id,
      cover: this.state.productCover,
      title: this.state.productTitle,
      url: this.state.productUrl,
      price: this.state.productPrice
    };
    let params = {
      method: 'POST',
      headers: API.jsonHeader,
      body: JSON.stringify(sendData)
    };
    fetch(API.postUpdateProduct.replace(':id',this.state.product._id), params).then(res => res.json())
      .then(json => {
      if(json.status == 0){
        window.location.reload()
      }
    })
  }
  saveProduct(){
    let sendData = {
      cover: this.state.productCover,
      title: this.state.productTitle,
      url: this.state.productUrl,
      price: this.state.productPrice,
      city_id: this.state.city_id,
      article_id: this.props.params.id,
      for_business: true
    };
    let params = {
      method: 'POST',
      headers: API.jsonHeader,
      body: JSON.stringify(sendData)
    };
    fetch(API.postProduct, params).then(res => res.json())
    .then(json => {
      if(json.status == 0){
        window.location.reload()
      }
    })
  }
  checkOauth(){
    let sendData = {
      business_id: this.props.params.bid,
      article_id: this.props.params.id
    }
    let param = {
      method: 'POST',
      body: JSON.stringify(sendData),
      headers: API.jsonHeader
    }
    fetch(`${API.getBusinessCheckOAuth}`,param).then(res=>res.json()).then(json=>{
      if(json.status == 0){
        let result = json.result
        this.setState({
          oauth: result.oauth,
          businessOauth: result.businessOauth
        })
      }
    });
  }
  handleTextChange(event) {
    let state = {};
    state[event.target.name] = event.target.value;
    this.setState(state);
  }
  render(){
    let navigator;
    if(!this.state.isShare){
      navigator = <Navigator action='left' number={2} />
    }else{
      navigator = <Navigator action='home' path={'/business/' + this.props.params.bid} number={2} />
    }
    let postCardReveal;
    if(this.state.showPostCard&&this.state.album._id){
      const texts = this.state.album.name.split('|')
      postCardReveal = <PostCardComponent
                         title = {texts[0]}
                         desc = {texts[1]}
                         cover = {this.state.album.cover}
                         togglePostCard = {this.togglePostCard}
                       />
    }
  	return (
  	  <div className="Business-Article-component">
        {this.state.oauth?
          <BusinessBrief
            article={this.state.album}
            count={this.state.albumMedia.length}
            isAuthor={this.state.isAuthor}
            business={this.state.business}
          />:null}
        {this.state.oauth?
          <div className="content">
            <BusinessMediaList
              medias={this.state.albumMedia}
              watermark={this.state.business.name}
              product={this.state.product}
              view_article={this.state.album.view_article}
              ad_url={this.state.business.ad_url}
            />
          </div>:null}
        {this.state.businessOauth&&this.state.oauth?(
          <div className="invite">
            <div className="title fz-12 text-gray">邀请代理</div>
            <div className="content">
              <p className="mt-15 text-gray">{this.state.invite_url}</p>
              <button onClick={this.getInviteUrl} className="button width-all">获取链接</button>
              <div className="fz-12 text-gray width-all pt-10">长按复制链接或者ctrl+C ctrl+A</div>
            </div>
            <div className="title fz-12 text-gray mt-30">更改行程</div>
            <div className="content">
              <input type="text" className="mt-15 text-gray" name="productTitle" onChange={this.handleTextChange} value={this.state.productTitle} placeholder="行程标题" />
              <input type="text" className="mt-15 text-gray" name="productUrl" onChange={this.handleTextChange} value={this.state.productUrl} placeholder="行程链接" />
              <input type="number" className="mt-15 text-gray" name="productPrice" onChange={this.handleTextChange} value={this.state.productPrice} placeholder="行程价格" />
              <input type="file" className="mt-15 text-gray mb-0" name="pic" onChange={this.picUpload} multiple="multiple" />
              {this.state.firstUpload?<Progress percent={this.state.fileProgress} />:null}
                <div className="mt-15">
                  <div className="fz-12 text-gray width-all pb-5">首次添加需要选择城市:</div>
                  <input type="text" className="text-gray mb-0" name="city_name" placeholder="必填（城市如：悉尼)" onChange={this.onCityInputChange} value={this.state.city_name}/>
                  <div className="fz-12 text-gray width-all pt-5">不清楚城市名称可直接输入国家名称</div>
                  <ul className="accordion cities">
                    {this.state.cities&&this.state.cities.map(city=>{
                      return (
                        <li className="accordion-item city" key={city._id} onClick={this.pickCity.bind(this, city)}>
                          <span className="accordion-title">{city.name}</span>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              <div className="mt-15">
                <button onClick={this.state.product.is_random?this.saveProduct:this.updateProduct} className="button width-all">保存行程</button>
                <div className="fz-12 text-gray width-all pt-10">请仔细检查文案后再保存</div>
              </div>
            </div>
            <div className="title fz-12 text-gray mt-30">更改文章</div>
            <div className="content">
              <input type="text" className="mt-15 text-gray" name="name" value={this.state.name} onChange={this.handleTextChange} placeholder="文章标题" />
              <textarea className="mt-15 text-gray mb-20" name="desc" value={this.state.desc} onChange={this.handleTextChange} placeholder="如果我们无法探索宇宙，一定要把这颗星球看一看~~" />
              <button onClick={this.updateArticle} className="button width-all">保存文章</button>
              <div className="fz-12 text-gray width-all pt-10">请仔细检查文案后再保存</div>
            </div>
          </div>
        ):null}
        {postCardReveal}
        <Navigator action='share' number={3} callback={this.togglePostCard} />
        <Navigator action='top' />
        {navigator}
  	  </div>
  	);
  }
}

BusinessArticleComponent.displayName = 'BusinessArticleComponent';

export default BusinessArticleComponent;



// WEBPACK FOOTER //
// ./src/components/BusinessArticleComponent.js